export enum ETypeChampAttribut
{
    Texte = 1,
    Numerique = 2,
    Decimales = 3,
    Date = 4,
    Booleen = 5
}

export function getTypeChamp(type: ETypeChampAttribut): string {
    switch (type) {
        case ETypeChampAttribut.Texte:
            return "text";
        case ETypeChampAttribut.Numerique:
            return "numeric";
        case ETypeChampAttribut.Decimales:
            return "decimal";
        case ETypeChampAttribut.Date:
            return "date";
        case ETypeChampAttribut.Booleen:
            return "boolean";
    }
}

